import {Controller} from '@hotwired/stimulus';

/**
 * N'affiche d'un sélecteur à vignettes que les vignettes qui correspondent au choix fait dans un autre.
 *
 *   <div {{ stimulus_controller('image-choice-default', {field: form.listing_type.vars.name})
 *         |stimulus_controller('image-choice-filter', {field: form.listing_type.vars.name, attribute: 'listing-type'})
 *         |stimulus_action('image-choice-filter', 'update', 'click') }}>
 *     {{ macros.form_text_image_simple(form.listing_type, form) }}
 *     {{ macros.form_text_image_simple(form.disposition_type, form) }}
 *   </div>
 *
 * Le lien de chaque image filtrée prend la classe `d-none` quand son attribut `data-<attribute>`
 * diffère de la valeur du champ caché d'id `field`, et la perd sinon : à la connexion, puis à chaque
 * `update`. Une vignette masquée reste sélectionnée. La valeur n'est lue qu'à ces moments : un
 * `image-choice-default` du même champ se pose avant ce contrôleur dans `data-controller`, pour que
 * la connexion lise la valeur par défaut qu'il écrit.
 *
 * Sans `choices`, les images filtrées sont celles du bloc qui portent l'attribut. Avec `choices`, nom
 * du champ des vignettes filtrées (`choices: form.disposition_type.vars.name`), ce sont toutes les
 * images de ses vignettes `.<choices>_button` : celle qui ne porte pas l'attribut est toujours masquée.
 */
export default class extends Controller {
  static values = {
    field: String,
    attribute: String,
    choices: String,
  };

  connect() {
    this.update();
  }

  update() {
    const input = this.element.querySelector(`input[type="hidden"]#${CSS.escape(this.fieldValue)}`);

    if (input === null) {
      return;
    }

    const attribute = `data-${this.attributeValue}`;
    const selector = this.choicesValue !== '' ?`.${CSS.escape(this.choicesValue)}_button img` : `img[${attribute}]`;

    this.element.querySelectorAll(selector).forEach((image) => {
      image.parentElement.classList.toggle('d-none', image.getAttribute(attribute) !== input.value);
    });
  }
}
